import { getStatusText } from "@component/statusbadgestailwind/StatusBadge";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";

export const handleDownloadClick = ({ table }) => {
  const allColumns = table
    .getAllColumns()
    .map((item) => {
      return { id: item.id, label: item.columnDef.header };
    })
    .filter(({ id }) => id !== "view");
  const visibleColumns = table
    .getVisibleFlatColumns()
    .map((item) => item.id)
    .filter((id) => id !== "view");
  const initialSelectedColumns = allColumns.map((col) => {
    return {
      id: col.id,
      isVisible: visibleColumns.includes(col.id),
      label: col.label, // Set visibility based on whether the column is in visibleColumns
    };
  });
  return {
    initialSelectedColumns,
  };
};

export const exportFile = (fileType, data, moduleNTabName) => {

  const timeStamp = new Date().toISOString().replace(/[:.]/g, '-');
  const fileName = `${moduleNTabName}_${timeStamp}`;
  // Create a worksheet from the data array
  const worksheet = XLSX.utils.json_to_sheet(data);
  // Create a new workbook
  const workbook = XLSX.utils.book_new();
  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  // Create the output file
  let fileExtension = "";
  // let fileName = "ExportedData";
  switch (fileType) {
    case "csv":
      fileExtension = ".csv";
      XLSX.writeFile(workbook, `${fileName}${fileExtension}`, {
        bookType: "csv",
      });
      break;
    case "xlsx":
      fileExtension = ".xlsx";
      XLSX.writeFile(workbook, `${fileName}${fileExtension}`, {
        bookType: "xlsx",
      });
      break;
    case "pdf":
      fileExtension = ".pdf";
      const pdf = new jsPDF();
      const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets["Sheet1"]);
      pdf.autoTable({
        head: [Object.keys(jsonData[0])],
        body: jsonData.map((row) => Object.values(row)),
      });
      pdf.save(`${fileName}${fileExtension}`);
      break;
    default:
      console.error("Invalid file type specified.");
      break;
  }
};

const sanitizeKey = (key) => {
  return key.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\s+/g, " ").trim().replace(/\b\w/g, (c) => c.toUpperCase());
};



const getKeyType = (key) => {
  const lowerKey = key.toLowerCase();

  if (lowerKey.includes("date")) return "date";
  if (lowerKey.includes("status") || lowerKey.includes("statsu")) return "status";

  return "";
};


export const exportFilesDataMatch = (format,structure) => {
  const otherKeys = Object.keys(structure);
  let results = otherKeys.filter((key)=>!(format.some((item) => item.accessorKey === key)));
  results = results.map((key)=>{
    return {
      displayName: sanitizeKey(key),
      accessorKey: key,
      type: getKeyType(key),
      checked:true
    }
  })
  results = [...format,...results]
  return results
}


const stringifyNested = (data, indent = 0) => {
  const pad = "  ".repeat(indent);
  let result = "";

  if (Array.isArray(data)) {
    if (data.every(v => typeof v !== "object")) {
      result += `${pad}${data.join(", ")}\n`;
    } else {
      data.forEach(item => {
        result += `${pad}\n`;
        result += stringifyNested(item, indent + 1);
      });
    }
    return result;
  }

  if (typeof data === "object" && data !== null) {
    Object.entries(data).forEach(([key, value]) => {
      if (typeof value === "object" && value !== null) {
        result += `${pad}${sanitizeKey(key)}:\n`;
        result += stringifyNested(value, indent + 1);
      } else {
        result += `${pad}${sanitizeKey(key)}: ${value || 'N/A'}\n`;
      }
    });
    return result;
  }

  return `${pad}${data}\n`;
};


const getJsonData = (value) => stringifyNested(value);


export const exportFileFormat = (format = [], data = []) => {
  let results = data && data?.length ? JSON.parse(JSON.stringify(data)) : data;
  results = results.map((item) => {
    const obj = {};
    format.forEach(({ accessorKey, displayName , type = '' }) => {
      let value = accessorKey.split('.').reduce((acc, key) => acc?.[key], item);
      const actualKey = accessorKey.split('.')?.[0] || accessorKey;
      if(value){
        value = Array.isArray(value) || typeof value === 'object' ? getJsonData(value) : value;
        value = type === 'date' ? new Date(value).toLocaleDateString() : type === 'status' ? getStatusText(value) : value;
      }
      else value = '';
       obj[displayName] = value
        delete item?.[actualKey];
    });
    return obj;
  });
  return results;
};
